module.exports = __webpack_public_path__ + "img/decor1.eef13564.svg";